/**
 * API utility for submitting to the v2 Lead Gen API (see ClickUp "Lead Gen V2
 * Contracts" doc). Distinct from the legacy v1 `submitConnectEnquiry` in
 * connect-enquiry-api.js, which other products still use.
 */

const baseHeaders = {
  "Content-Type": "application/json",
  "x-channel": "CONTRACTOR_WEB",
};

export async function createLeadGenV2(payload, contractorId) {
  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || process.env.BASE_URL;

  if (!baseUrl) {
    throw new Error("BASE_URL is not configured");
  }

  const headers = contractorId
    ? { ...baseHeaders, "X-USER-ID": contractorId }
    : baseHeaders;

  const response = await fetch(`/v2/api/lead-gen`, {
    method: "POST",
    headers,
    body: JSON.stringify(payload),
  });

  const rawBody = await response.text();
  let body = null;
  if (rawBody) {
    try {
      body = JSON.parse(rawBody);
    } catch {
      body = null;
    }
  }

  if (body?.result?.response?.status === "SUCCESS") {
    return body.result.data ?? null;
  }

  const errorMessage =
    body?.result?.response?.message ||
    body?.error?.message ||
    body?.message ||
    `HTTP ${response.status}: ${response.statusText}`;

  const error = new Error(errorMessage);
  error.status = response.status;
  error.data = body;
  throw error;
}
